// Pure helpers for deadline overrun enforcement. No React, no data dependency.
import { todayIso, deadlineDaysLeft } from './format.js';

// Statuses where a deadline still "counts" and an overrun must be addressed.
// done / cancelled / archived are finished — their countdown is frozen and they
// never trigger the enforcement dialog. Paused (on_hold) DOES count.
export const OPEN_DEADLINE_STATUSES = new Set(['active', 'closing', 'on_hold']);

export function isOpenForDeadline(project) {
  return !!project && OPEN_DEADLINE_STATUSES.has(project.status);
}

// An open project whose deadline lies strictly before today.
export function isOverdue(project, today = todayIso()) {
  return isOpenForDeadline(project) && !!project.deadline && project.deadline < today;
}

// Fälligkeit einer Aufgabe: ihr eigenes Datum, sonst — wenn keins gesetzt ist —
// die Deadline des Projekts. Frontend und MCP-Server rechnen beide so.
export function taskDueDate(task, project) {
  return task?.due_date || project?.deadline || null;
}

// Eine offene Aufgabe, deren Fälligkeit vor heute liegt.
export function isTaskOverdue(task, project, today = todayIso()) {
  if (!task || task.done) return false;
  const due = taskDueDate(task, project);
  return !!due && due < today;
}

// Whole days a deadline has been missed (>= 1 when overdue, else 0).
export function overdueDays(deadline, ref = new Date()) {
  const left = deadlineDaysLeft(deadline, ref);
  return left == null ? 0 : Math.max(0, -left);
}
